function quickViewModal() {
  return {
    isOpen: false,
    loading: false,
    addingToCart: false,
    product: null,
    currentImage: '',
    selectedOptions: [],
    currentVariant: null,
    quantity: 1,
    isWishlisted: false,
    currentPrice: 0,
    originalPrice: 0,
    activeIndex: 0,

    init() {
      this.$watch('isOpen', (value) => {
        if (value) {
          const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
          document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
          document.body.classList.add('quick-view-open');
        } else {
          document.body.classList.remove('quick-view-open');
        }
      });

      window.addEventListener('open-quick-view', (e) => {
        this.open(e.detail.productHandle || e.detail.handle);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });
    },

    async open(handle) {
      if (!handle) return;
      this.isOpen = true;
      this.loading = true;
      this.activeIndex = 0;

      try {
        const response = await fetch(`/products/${handle}.js`);
        this.product = await response.json();

        this.currentImage = this.product.images[0];
        this.selectedOptions = this.product.options.map((opt) => opt.values[0]);
        this.updateVariant();

        this.loading = false;
      } catch (error) {
        console.error('Error loading product:', error);
        this.loading = false;
      }
    },

    nextSlide() {
      if (!this.product) return;
      this.activeIndex = (this.activeIndex + 1) % this.product.images.length;
      this.currentImage = this.product.images[this.activeIndex];
    },

    prevSlide() {
      if (!this.product) return;
      this.activeIndex = (this.activeIndex - 1 + this.product.images.length) % this.product.images.length;
      this.currentImage = this.product.images[this.activeIndex];
    },

    close() {
      this.isOpen = false;
      this.product = null;
      this.quantity = 1;
      this.isWishlisted = false;
      this.addingToCart = false;
      this.activeIndex = 0;
    },

    updateVariant() {
      if (!this.product) return;

      this.currentVariant = this.product.variants.find((variant) => {
        return variant.options.every((opt, i) => opt === this.selectedOptions[i]);
      });

      if (this.currentVariant) {
        this.currentPrice = this.currentVariant.price;
        this.originalPrice = this.currentVariant.compare_at_price || this.currentVariant.price;
        if (this.currentVariant.featured_image) {
          this.currentImage = this.currentVariant.featured_image.src;

          // Sync activeIndex with the featured image
          const imgIndex = this.product.images.indexOf(this.currentImage);
          if (imgIndex !== -1) {
            this.activeIndex = imgIndex;
          }
        }
      } else {
        this.currentPrice = this.product.price;
        this.originalPrice = this.product.compare_at_price || this.product.price;
      }
    },

    toggleWishlist() {
      this.isWishlisted = !this.isWishlisted;
    },

    async addToCart() {
      if (!this.currentVariant || this.addingToCart) return;

      this.addingToCart = true;

      try {
        const formData = new FormData();
        formData.append('id', String(this.currentVariant.id));
        formData.append('quantity', String(this.quantity));
        formData.append('sections', ''); // Replicate Theme standard

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData,
        });

        const textContent = await response.text();
        let data;
        try {
          data = JSON.parse(textContent);
        } catch (e) {
          console.error('QuickView: Failed to parse response as JSON:', textContent.substring(0, 500));
          alert('Server returned HTML instead of JSON. Check console for details.');
          return;
        }

        if (response.ok) {
          window.dispatchEvent(new CustomEvent('cart-updated'));
          window.dispatchEvent(new CustomEvent('open-cart-drawer'));
          this.close();
        } else {
          alert(data.description || data.message || 'Error adding to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      } finally {
        this.addingToCart = false;
      }
    },

    viewFullDetails() {
      window.location.href = `/products/${this.product.handle}`;
    },

    findInStore() {
      // Placeholder/Redirect for store locator
      window.location.href = '/pages/find-store';
    },

    formatMoney(cents) {
      if (cents === null || cents === undefined) return "$0.00";
      const value = (cents / 100).toFixed(2);
      const formatWithCommas = (val) => val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // Fallback to currency formatting if possible, otherwise manual
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(cents / 100);
      } catch (e) {
        return '$' + formatWithCommas(value);
      }
    },
  };
}